import { useCallback, useState } from 'react';

export interface IUseVisibilityHook {
  isOpen: boolean;
  handleClose: () => void;
  handleOpen: () => void;
  toggleOpen: () => void;
  setIsOpen: (value: boolean) => void;
}

export function useVisibility(initialState = false): IUseVisibilityHook {
  const [isOpen, setIsOpen] = useState(initialState);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return {
    handleClose,
    handleOpen,
    isOpen,
    setIsOpen,
    toggleOpen,
  };
}
